import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'cd-ui-react/components/popover';
import Button from 'cd-ui-react/components/button';
import RadioGroup from 'cd-ui-react/components/radiogroup';
import Radio from 'cd-ui-react/components/radio';
import Input from '../input';
import Icon from 'cd-ui-react/components/icon';
import Tooltip from 'cd-ui-react/components/tooltip';
import ComponentsUtil, {KeyCodes} from '../../utils/ComponentsUtil';
import BusyOverlay from '../busy-overlay';
import styles from './wrapupdialog.css';
import {i18n} from '../../utils/GadgetUtils';

class WrapupDialog extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			filteredList: props.wrapUpReasons.options || []
		};
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		if (!this.props.show && nextProps.show) {
			this.setState({
				filteredList: this.props.wrapUpReasons.options || []
			}, () => {
				ComponentsUtil.setFocusByElementID('input-wrapupSearch-' + this.props.id);
			});
		}
	}

	filterReason = event => {
		let currentList = this.props.wrapUpReasons.options;
		currentList = currentList.filter((item) =>
			item.label.toLowerCase().search(event.target.value.toLowerCase()) !== -1
		);
		this.setState({filteredList: currentList});
	}

	cancelAction = () => {
		/* Setting focus on the Wrapup button on Cancel Click */
		ComponentsUtil.setFocusByElementID('button-wrapup-' + this.props.id);
		this.props.onDismiss();
	}

	keyDown = (e) => {
		if (e.keyCode === KeyCodes.KEY_ESC) {
			e.stopPropagation(); e.preventDefault();
			ComponentsUtil.setFocusByElementID('button-wrapup-' + this.props.id);
		}
	}

	render () {
		let { show, onDismiss, toggleWrapupSelection, handleApplyClick, wrapUpReasons, showSpinner, id, shouldDisableApply, wrapUpApplyError, selectedWrapupReason } = this.props;
		let { selectedWrapupOption } = this.props;
		return (
			<Popover className={`${styles.wrapupdialogContainer}`} placement="bottom" show={show} target={`button-wrapup-${id}`} onDismiss={onDismiss} chevron >
				<div onKeyDown={this.keyDown}>
					<div className={styles.wrapupInner}>
						<Input
							searchable
							id={`input-wrapupSearch-${id}`}
							type="text"
							style={{fontSize: '12px'}}
							className={`${styles.wrapupdialogSearch}`}
							onChange={this.filterReason}
							smallsearchiconsize={"16"}
						/>
						<div className={styles.wrapupContainer}>
							<div className={styles.wrapupTagContainer}>
								{selectedWrapupReason &&
								<Tooltip showOnlyForTruncatedText id={id}
									data-index-number="0"
									className="overflow-hidden width100"
									chevron placement="left"
									content={selectedWrapupReason}>
									<div id={`selected-wrapupReason-${id}`} aria-label={selectedWrapupReason} role="option"
										className={`${styles.wrapupSelectedTag} ${styles.wrapupReasonEllipsis} ${styles.wrapupReasonSelectedTag} `} >
										{window.finesse.utilities.Utilities.translateHTMLEntities(selectedWrapupReason, false)}
									</div>
								</Tooltip>}
							</div>

							<div className={styles.wrapupOptionsContainer}>
								{wrapUpReasons.options && wrapUpReasons.options.length > 0 && <div className={`flex ${styles.wrapupdialogOptions}`}>
									<RadioGroup className={`flex-col`} selected={selectedWrapupOption} onChange={toggleWrapupSelection} name="wrapupCodes" >
										{
											this.state.filteredList.map((reason, index) => {
												const labelWithTooltip = <Tooltip showOnlyForTruncatedText id={id}
													data-index-number={index}
													content={ComponentsUtil.encodeSpecialChars(reason.label)}
													chevron placement="left">
													<div className={`${styles.wrapupReasonEllipsis} ${styles.wrapupReasonOption}`} aria-label={reason.label} role="option">{reason.label}</div>
												</Tooltip>;
												return (
													<Radio className={styles.radioPadding} key={index} label={labelWithTooltip} value={reason.value} data-value={reason.value} />
												);
											})
										}
									</RadioGroup>
								</div>}
							</div>
						</div>
					</div>
					<div style={{borderTop: '1px solid #D7D7D8'}} >
						<div className={styles.wrapupButtons}>
							<Button
								id={`button-cancel-${id}`}
								className={`mar-right-05r ${styles.wrapupCancelButton} align-item-center`}
								onClick={this.cancelAction}>
								{i18n.getMsg('gadget.imi.operation.cancel')}
							</Button>
							<Button
								id={`button-apply-${id}`}
								className="bg-blue mar-left-05r align-item-center"
								style={{width: '100px', height: '36px'}}
								color="blue"
								size="large"
								disabled={shouldDisableApply}
								onClick={handleApplyClick}>
								{i18n.getMsg('gadget.imi.operation.apply')}
							</Button>
						</div>
						{wrapUpApplyError && <div className={`flex ${styles.wrapupdialogError}`}>
							<Icon name="error" size="16" color="red" />
							<span>{i18n.getMsg('gadget.imi.error.operation.failed')}</span>
						</div>}
					</div>
					<BusyOverlay show={showSpinner} showSpinner spinnerPosition="center" spinnerSize="xlarge" />
				</div>
			</Popover>
		);
	}
}

WrapupDialog.propTypes = {
	/* Boolean flag to indicate whether wrapup dialog is open or closed */
	show: PropTypes.bool,
	/* Callback function to be invoked when dialog is closed */
	onDismiss: PropTypes.func,
	/* Callback function to be invoked when agent changes wrapup selection */
	toggleWrapupSelection: PropTypes.func,
	/* Callback to be invoked when apply button is clicked */
	handleApplyClick: PropTypes.func,
	/* Busy indicator when operation is in progress */
	showSpinner: PropTypes.bool,
	/* configured wrapup reasons for the logged in agent */
	wrapUpReasons: PropTypes.shape({
		options: PropTypes.array
	}),
	/* Unique call id */
	id: PropTypes.string,
	/* Boolean flag to indicate if apply button should be disabled */
	shouldDisableApply: PropTypes.bool,
	/* Boolean variable to indicate if some error has occured while applying reason  */
	wrapUpApplyError: PropTypes.bool,
	/* Currently applied reason code */
	selectedWrapupReason: PropTypes.string,
	/* Currently selected reason code */
	selectedWrapupOption: PropTypes.string
};

export default WrapupDialog;
